<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M100 196.148C155.228 196.148 200 153.134 200 100.074C200 47.0138 155.228 4 100 4C44.7715 4 0 47.0138 0 100.074C0 153.134 44.7715 196.148 100 196.148Z"
    fill="url(#paint0_radial_44848_31368)" />
  <path
    d="M65.8822 176.068C53.8975 176.068 45.1168 174.474 33.8608 172.134C51.8622 186.738 72.2268 196.312 97.6295 195.895C156.678 194.926 193.129 158.206 199.548 109.266C169.812 149.77 121.396 176.068 65.8822 176.068Z"
    fill="url(#paint1_linear_44848_31368)" />
  <path opacity="0.2"
    d="M138.197 131.134C156.254 131.134 170.892 116.198 170.892 97.7744C170.892 79.3505 156.254 64.415 138.197 64.415C120.14 64.415 105.502 79.3505 105.502 97.7744C105.502 116.198 120.14 131.134 138.197 131.134Z"
    fill="#30688A" />
  <path
    d="M105.063 94.4614C105.026 112.704 119.488 127.52 137.364 127.559C155.242 127.595 169.766 112.838 169.804 94.5967C169.842 76.3547 155.382 61.5374 137.502 61.5001C119.626 61.4627 105.1 76.2214 105.063 94.4614Z"
    fill="#30688A" />
  <path
    d="M108.132 94.4662C108.098 110.98 121.189 124.392 137.372 124.427C153.554 124.462 166.701 111.103 166.736 94.5889C166.77 78.0776 153.679 64.6643 137.498 64.6309C121.314 64.5976 108.166 77.9549 108.132 94.4662Z"
    fill="url(#paint2_radial_44848_31368)" />
  <path opacity="0.2"
    d="M137.381 119.771C152.796 119.804 165.446 107.684 166.644 92.2623C166.7 93.0316 166.738 93.8063 166.736 94.5897C166.702 111.104 153.555 124.462 137.372 124.428C121.19 124.392 108.099 110.981 108.133 94.467C108.134 93.6836 108.174 92.9096 108.235 92.1396C109.368 107.564 121.967 119.738 137.381 119.771Z"
    fill="#00375A" />
  <path
    d="M114.751 93.7444C114.735 102.059 121.461 108.814 129.776 108.83C138.09 108.849 144.846 102.121 144.864 93.8064C144.882 85.4904 138.154 78.7371 129.84 78.7198C121.524 78.7024 114.768 85.4278 114.751 93.7444Z"
    fill="#4EC2EE" />
  <path
    d="M120.34 93.7554C120.331 97.956 123.73 101.369 127.929 101.378C132.131 101.387 135.544 97.988 135.552 93.7894C135.559 89.586 132.162 86.1747 127.961 86.166C123.761 86.156 120.348 89.556 120.34 93.7554Z"
    fill="#001C2D" />
  <path opacity="0.33"
    d="M130.721 90.957C130.701 99.803 137.856 106.988 146.702 107.008C155.549 107.025 162.735 99.8703 162.754 91.023C162.773 82.179 155.617 74.9923 146.77 74.9737C137.925 74.9563 130.738 82.1123 130.721 90.957Z"
    fill="white" />
  <path
    d="M122.164 90.6213C120.022 90.6168 118.281 92.281 118.277 94.3385C118.272 96.3959 120.006 98.0674 122.149 98.0719C124.292 98.0764 126.032 96.4122 126.037 94.3547C126.041 92.2973 124.307 90.6258 122.164 90.6213Z"
    fill="white" />
  <path opacity="0.2"
    d="M61.1546 131.103C79.2114 131.103 93.8493 116.168 93.8493 97.7441C93.8493 79.3202 79.2114 64.3848 61.1546 64.3848C43.0979 64.3848 28.46 79.3202 28.46 97.7441C28.46 116.168 43.0979 131.103 61.1546 131.103Z"
    fill="#30688A" />
  <path opacity="0.25"
    d="M61.8342 126.605C79.2286 126.605 93.3295 112.218 93.3295 94.4709C93.3295 76.7238 79.2286 62.3369 61.8342 62.3369C44.4398 62.3369 30.3389 76.7238 30.3389 94.4709C30.3389 112.218 44.4398 126.605 61.8342 126.605Z"
    fill="#30688A" />
  <path
    d="M28.5875 94.3604C28.5481 112.546 42.9668 127.318 60.7901 127.356C78.6148 127.395 93.0922 112.681 93.1328 94.4937C93.1708 76.3091 78.7542 61.5397 60.9282 61.5011C43.1068 61.4631 28.6268 76.1751 28.5875 94.3604Z"
    fill="#30688A" />
  <path
    d="M31.6485 94.3665C31.6118 110.828 44.6632 124.199 60.7972 124.234C76.9298 124.267 90.0358 110.951 90.0712 94.4885C90.1052 78.0265 77.0565 64.6538 60.9212 64.6212C44.7872 64.5865 31.6798 77.9052 31.6485 94.3665Z"
    fill="url(#paint3_radial_44848_31368)" />
  <path opacity="0.2"
    d="M60.806 119.593C76.174 119.625 88.788 107.543 89.9827 92.1692C90.036 92.9332 90.0734 93.7086 90.0707 94.4892C90.0354 110.951 76.93 124.267 60.7967 124.235C44.6627 124.2 31.6114 110.829 31.648 94.3672C31.6494 93.5879 31.6887 92.8119 31.7467 92.0459C32.8767 107.426 45.4394 119.561 60.806 119.593Z"
    fill="#00375A" />
  <path
    d="M48.6475 93.647C48.6282 101.936 55.3348 108.67 63.6228 108.688C71.9142 108.704 78.6508 101.998 78.6695 93.7077C78.6855 85.419 71.9782 78.6844 63.6895 78.667C55.3975 78.649 48.6628 85.357 48.6475 93.647Z"
    fill="#4EC2EE" />
  <path
    d="M55.6299 93.3157C55.6226 97.5031 59.0112 100.904 63.1986 100.913C67.3866 100.922 70.7892 97.5351 70.7979 93.3471C70.8052 89.1591 67.4192 85.7584 63.2312 85.7471C59.0412 85.7397 55.6412 89.1304 55.6299 93.3157Z"
    fill="#001C2D" />
  <path opacity="0.33"
    d="M33.5874 90.8202C33.5721 98.6155 39.8781 104.951 47.6768 104.968C55.4741 104.983 61.8088 98.6742 61.8254 90.8782C61.8428 83.0795 55.5328 76.7469 47.7361 76.7295C39.9374 76.7129 33.6048 83.0229 33.5874 90.8202Z"
    fill="white" />
  <path
    d="M67.9453 95.5C67.9393 97.5506 69.6687 99.216 71.806 99.22C73.9413 99.2253 75.678 97.566 75.6827 95.5153C75.688 93.464 73.9593 91.7966 71.8213 91.794C69.6867 91.786 67.9493 93.4453 67.9453 95.5Z"
    fill="white" />
  <path opacity="0.33"
    d="M79.4444 39.0957C92.9577 36.5377 103.094 30.1411 102.085 24.8084C101.075 19.4757 89.3022 17.2264 75.7888 19.7844C62.2755 22.3424 52.1391 28.739 53.1486 34.0717C54.158 39.4044 65.931 41.6537 79.4444 39.0957Z"
    fill="white" />
  <path
    d="M60.5181 136.466C60.5181 136.466 83.3914 147.687 80.0914 160.396C78.3641 167.044 110.857 166.417 115.633 164.302C122.451 161.282 133.025 140.544 133.025 137.544C133.025 134.546 112.523 151.787 60.5181 136.466Z"
    fill="#720D53" />
  <path
    d="M64.0239 135.271C64.0239 135.271 96.3246 149.291 130.01 135.894C130.01 135.894 126.782 132.155 132.319 133.091C137.857 134.025 144.339 140.897 140.145 140.567C136.045 140.243 133.242 137.452 133.242 137.452C133.242 137.452 122.546 147.076 94.3979 145.205C66.2492 143.337 60.7946 136.829 60.7946 136.829C60.7946 136.829 54.5346 140.171 53.6126 138.3C52.6886 136.431 68.1966 128.442 64.0239 135.271Z"
    fill="#00375A" />
  <path
    d="M117.418 161.999C113.237 159.466 106.285 156.273 98.1479 156.592C87.0199 157.03 81.5359 160.197 80.0312 161.228C80.9873 167.019 111.787 167.49 115.633 164.302C116.208 163.826 116.81 163.022 117.418 161.999Z"
    fill="#D541A0" />
  <path opacity="0.51"
    d="M104.107 156.965C102.509 156.707 100.834 156.569 99.1013 156.58C97.0647 158.769 94.3987 162.542 95.978 166.084C97.012 166.148 98.0527 166.194 99.0907 166.224C99.4973 163.802 100.461 160.164 104.107 156.965Z"
    fill="#720D53" />
  <path
    d="M87.6914 169.137C87.6914 169.137 102.581 173.153 111.549 168.635C111.549 168.635 104.162 180.658 87.6914 169.137Z"
    fill="#00375A" />
  <path
    d="M67.9382 27.5498C67.9382 27.5498 51.9948 32.8038 44.9648 38.2591C37.9342 43.7158 37.3755 46.6331 37.3755 46.6331C37.3755 46.6331 57.4622 36.6151 62.3935 36.8898L67.2195 36.6538C67.2195 36.6538 69.4208 29.9398 67.9382 27.5498Z"
    fill="#00375A" />
  <path
    d="M133.626 21.625C133.626 21.625 149.888 30.2817 156.473 37.4957C163.059 44.707 163.121 47.9683 163.121 47.9683C163.121 47.9683 143.623 33.1303 138.237 32.509L132.705 31.607C132.705 31.6063 131.576 23.9337 133.626 21.625Z"
    fill="#00375A" />
  <defs>
    <radialGradient id="paint0_radial_44848_31368" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
      gradientTransform="translate(95.1477 55.7427) scale(262.019 262.019)">
      <stop offset="0.0224" stop-color="#E4F3FC" />
      <stop offset="0.4088" stop-color="#53C3EE" />
      <stop offset="0.5866" stop-color="#006EB4" />
      <stop offset="1" stop-color="#00A2DE" />
    </radialGradient>
    <linearGradient id="paint1_linear_44848_31368" x1="126.652" y1="161.215" x2="137.737" y2="184.078"
      gradientUnits="userSpaceOnUse">
      <stop offset="0.0224" stop-color="#001C2D" stop-opacity="0" />
      <stop offset="1" stop-color="#001C2D" stop-opacity="0.2" />
    </linearGradient>
    <radialGradient id="paint2_radial_44848_31368" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
      gradientTransform="translate(137.319 94.8119) rotate(-179.882) scale(29.6021 29.6021)">
      <stop stop-color="white" />
      <stop offset="0.6342" stop-color="white" />
      <stop offset="0.7821" stop-color="#EDF8FD" />
      <stop offset="1" stop-color="#CCECF8" />
    </radialGradient>
    <radialGradient id="paint3_radial_44848_31368" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
      gradientTransform="translate(61.023 94.6468) rotate(-179.884) scale(29.51 29.51)">
      <stop stop-color="white" />
      <stop offset="0.6342" stop-color="white" />
      <stop offset="0.7821" stop-color="#EDF8FD" />
      <stop offset="1" stop-color="#CCECF8" />
    </radialGradient>
  </defs>
</svg>